import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';

const Credits = () => {
  const [totalCredits] = useState(45.00);
  const [creditHistory] = useState([
    {
      id: 1,
      date: new Date('2024-03-10'),
      eventName: 'Spring Endurance Ride',
      creditChange: -20.00,
      description: 'Event registration discount applied'
    },
    {
      id: 2,
      date: new Date('2024-02-15'),
      eventName: 'Membership Renewal',
      creditChange: +50.00,
      description: 'Annual membership credit bonus'
    },
    {
      id: 3,
      date: new Date('2024-01-20'),
      eventName: 'Winter Series Completion',
      creditChange: +15.00,
      description: 'Completion bonus for winter series'
    }
  ]);

  const dateBodyTemplate = (rowData) => {
    return rowData.date.toLocaleDateString('en-GB');
  };

  const creditChangeBodyTemplate = (rowData) => {
    const isPositive = rowData.creditChange > 0;
    const className = isPositive ? 'text-green-600' : 'text-red-600';
    const prefix = isPositive ? '+' : '';
    return <span className={className}>{prefix}£{Math.abs(rowData.creditChange).toFixed(2)}</span>;
  };

  return (
    <div>
      {/* Total Credits Card */}
      <div className="grid mb-4">
        <div className="col-12 md:col-4">
          <Card className="text-center se-bg-secondary text-white">
            <h3 className="mt-0 mb-2">Total Credits Available</h3>
            <div className="text-4xl font-bold">£{totalCredits.toFixed(2)}</div>
            <p className="mb-0 mt-2 opacity-90">Use credits for event discounts and purchases</p>
          </Card>
        </div>
      </div>

      {/* Credit History */}
      <div className="se-card">
        <div className="se-card-header">
          <h2>Credit History</h2>
        </div>
        <div className="se-card-content">
          <DataTable value={creditHistory} responsiveLayout="scroll">
            <Column field="date" header="Date" body={dateBodyTemplate} sortable />
            <Column field="eventName" header="Event Name" sortable />
            <Column field="creditChange" header="Credit Change" body={creditChangeBodyTemplate} sortable />
            <Column field="description" header="Description" />
          </DataTable>
        </div>
      </div>
    </div>
  );
};

export default Credits;